// ═══════════════════════════════════════════════════════════════════
//  CourrielFiltres.js
//  Barre de filtres : recherche, étiquettes, réindexation — extrait de Courriel
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { MAIL_TAGS } from "./constantes";
import { filtreStyle } from "./utils";

export function CourrielFiltres({ charger, dossier, estBoiteRecue, filtre, recherche, setFiltre, setRecherche, stats }) {
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 12 }}>
    {estBoiteRecue && <button onClick={() => setFiltre("")} style={filtreStyle(filtre === "")}>Tous</button>}
    {estBoiteRecue && Object.keys(MAIL_TAGS).map((k) => (
      <button key={k} onClick={() => setFiltre(k)} style={filtreStyle(filtre === k, MAIL_TAGS[k])}>
        {MAIL_TAGS[k].label}
        {stats?.parTag?.find((t) => t.tag === k) && (
          <span style={{ opacity: .6, marginLeft: 5 }}>{stats.parTag.find((t) => t.tag === k).total}</span>
        )}
      </button>
    ))}
    <input
      value={recherche}
      onChange={(e) => setRecherche(e.target.value)}
      onKeyDown={(e) => e.key === "Enter" && charger()}
      placeholder={dossier === "sent" ? "Rechercher un destinataire, un objet…" : "Rechercher un expéditeur, un objet…"}
      style={{ flex: 1, minWidth: 200, background: THEME.panel, border: `1px solid ${THEME.border}`,
               borderRadius: 8, padding: "7px 12px", color: THEME.text, fontSize: 13, outline: "none" }}
    />
  </div>
  );
}
